import React from "react";
import Carousel from 'react-bootstrap/Carousel';

export default function CarouselImage({ imageList, recipesApp }) {
  return (
    <Carousel 
      className={ recipesApp ? "carousel-content-recipes-app" : "carousel-content" }
      interval={null}>
      {
        imageList && imageList.map((image, index) => (
          <Carousel.Item key={ `slide-${index}` } >
            <img
              className={ recipesApp ? "carousel-image-recipes-app" : "carousel-image"}
              src={ image }
              alt={ `slide--${index}` }
            />
          </Carousel.Item>
        ))
      }
    </Carousel>
  )
}